import createSagaMiddleware from 'redux-saga';
import combineSectionReducers from 'combine-section-reducers';
import {
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { rootSaga } from './sagas/rootSaga';
import { rootReducer } from './reducers/rootReducer.reducer';
import { INITIAL_STATE } from './initialState';
import { IAppState } from './appState';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { tiergruppeReducer } from './reducers/tiergruppe.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null): number => version,
  antragsnummer: (antragsnummer: string = null): string => antragsnummer,
  gesamtbeitrag: (gesamtbeitrag: number = null): number => gesamtbeitrag,
  savedGesamtbeitragMitRabatt: (savedGesamtbeitragMitRabatt: number = null): number =>
    savedGesamtbeitragMitRabatt,
  savedJahresbeitragMitRabatt: (savedJahresbeitragMitRabatt: number = null): number =>
    savedJahresbeitragMitRabatt,
  gesamtbeitragMitRabatt: (gesamtbeitragMitRabatt: number = null): number => gesamtbeitragMitRabatt,
  jahresbeitrag: (jahresbeitrag: number = null): number => jahresbeitrag,
  produkt: (produkt: IAppState['produkt'] = null): IAppState['produkt'] => produkt,
  rabattstufe: (rabattstufe: number = null): number => rabattstufe,
  taasInfo: (taasInfo: IAppState['taasInfo'] = null): IAppState['taasInfo'] => taasInfo,
  vertragsoptionen: (
    vertragsoptionen: IAppState['vertragsoptionen'] = null,
  ): IAppState['vertragsoptionen'] => vertragsoptionen,
  transientState: transientStateReducer,
  tiergruppe: tiergruppeReducer,
});

export function storeFactory(initialState: IAppState): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.TGV);
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension('tgv-angebot-gui'),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(
        sagaMiddleware,
        ngRefreshStore.ngRefreshMiddleware,
      ) as unknown as Tuple<
        ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>
      >,
  });
  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

export const localStore: PS20Store<IAppState> = storeFactory(INITIAL_STATE);

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return localStore.globalEventDispatcherRef;
};
